<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_monthlySummary"
      :custom="{storage: true}"
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('monthlySummary_list')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('monthlySummary_regenerate')"
          @click="funRegenerate"
        >
          重新生成
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="declarationMonth"
          title="申报月份"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.declarationMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="申报月份"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxRate"
          title="税率"
          min-width="110"
          :formatter="({ cellValue }) => formatterRate(cellValue)"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.taxRate"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in taxRateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverCount"
          title="申报人数"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.driverCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalIncomeAmount"
          title="收入额合计"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalIncomeAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.totalIncomeAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalTaxAmount"
          title="应纳税额合计"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalTaxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.totalTaxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          min-width="130"
          :formatter="({ cellValue }) => formatterStatus(cellValue)"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.status"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="failureMessage"
          title="失败原因"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.failureMessage"
            placeholder="请输入失败原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pushedAt"
          title="推送时间"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.pushedAtRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'pushedAt')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('monthlySummary_push') && scope.row.status !== 'SUCCESS'"
            class="item"
            effect="dark"
            content="推送汇总（该月全部税率）"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funPush(scope.row.id)"
            >
              <em class="el-icon-upload2" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import pageMixin from "@/mixins/pageMixin";
import {summaryList, summaryRegenerate, summaryPush} from "@/api/MonthlyTax";

export default {
  name: "MonthlySummaryReport",
  mixins: [pageMixin],
  data() {
    return {
      loading: false,
      tableData: [],
      statusOptions: [
        {value: "PENDING", label: "未推送"},
        {value: "PUSHING", label: "推送中"},
        {value: "SUCCESS", label: "推送成功"},
        {value: "FAILED", label: "推送失败"}
      ],
      taxRateOptions: [
        {label: "5%", value: 0.05},
        {label: "10%", value: 0.1},
        {label: "20%", value: 0.2},
        {label: "30%", value: 0.3},
        {label: "35%", value: 0.35}
      ],
      listQuery: {
        declarationMonth: "",
        taxRate: "",
        driverCountStart: "",
        driverCountEnd: "",
        totalIncomeAmountStart: "",
        totalIncomeAmountEnd: "",
        totalTaxAmountStart: "",
        totalTaxAmountEnd: "",
        status: "",
        failureMessage: "",
        pushedAtStart: "",
        pushedAtEnd: "",
        pushedAtRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    formatterStatus(cellValue) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterRate(cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === "") {
        return "-";
      }
      return (Number(cellValue) * 100).toFixed(2) + "%";
    },
    findList() {
      this.loading = true;
      return summaryList(this.listQuery).then(res => {
        this.tableData = res.data.records;
        this.listQuery.total = res.data.total;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    // 按申报月份重新生成
    funRegenerate() {
      if (!this.listQuery.declarationMonth) {
        this.$message.warning("请先选择申报月份");
        return;
      }
      this.$confirm(
        `确认重新生成 ${this.listQuery.declarationMonth} 的个税汇总数据吗？汇总将基于已推送成功的个税明细生成，推送成功的汇总记录将保留。`,
        "提示",
        {type: "warning"}
      ).then(async () => {
        const rLoading = this.openLoading();
        try {
          const res = await summaryRegenerate(this.listQuery.declarationMonth);
          const data = res.data || {};
          this.$message.success(
            `重新生成完成：个税成功 ${data.personalSuccess || 0} 条，汇总 ${data.summaryCount || 0} 条`
          );
        } catch (e) {
          // 拦截器已提示
        } finally {
          rLoading.close();
          this.findList();
        }
      }).catch(() => {});
    },
    // 逐条推送
    async funPush(id) {
      const rLoading = this.openLoading();
      try {
        const res = await summaryPush(id);
        this.$message.success(res.msg || "推送成功");
      } catch (e) {
        // 拦截器已提示
      } finally {
        rLoading.close();
        this.findList();
      }
    }
  }
};
</script>
